<i-title styleClass="w-100" [text]="'modals.fileSourceModification' | translate" [buttons]="titleButtons" level="1"></i-title>

<section class="form mb-4 p-4" [formGroup]="form">
  <div class="row">
    <div class="col-md-12 mb-3">
      <label class="super-compos-label-input">{{ 'modals.sourceSelection' | translate }}</label>
      <p-dropdown
        appendTo="body"
        [options]="sources"
        [placeholder]="'modals.selectSource' | translate"
        formControlName="editeurSourceType"
        id="dropdownEditeurSourceType"
        [showClear]="true"
        styleClass="w-100 dropdown-inforius">
      </p-dropdown>
    </div>
  </div>
</section>
